import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { AssessApiService } from '../../services/assess-api.service';
import {
  getInitialAssessment,
  getInitialAssessmentFailure,
  getInitialAssessmentSuccess,
  updateAssessment,
  updateAssessmentFailure,
  updateAssessmentSuccess,
} from '../actions/assessment.actions';

@Injectable()
export class AssessmentEffects {
  constructor(
    private actions$: Actions,
    private assessmentApiService: AssessApiService,
  ) {}

  getInitialAssessment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getInitialAssessment),
      exhaustMap(({ orgId, campaignId, assessmentId, invitationCode }) =>
        this.assessmentApiService.getInitialAssessment(orgId, campaignId, assessmentId, invitationCode).pipe(
          map(({ assessmentConfiguration, sessionId, assessmentId: loadedAssessmentId, nextTestlet }) =>
            getInitialAssessmentSuccess({
              testletConfig: {
                config: assessmentConfiguration,
                nextTestlet,
                sessionId,
                assessmentId: loadedAssessmentId,
              },
            }),
          ),
          catchError((error) => of(getInitialAssessmentFailure({ error }))),
        ),
      ),
    ),
  );

  updateAssessment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateAssessment),
      exhaustMap(({ orgId, campaignId, assessmentId, invitationCode, currentTestlet, sessionId, score, duration }) =>
        this.assessmentApiService
          .updateAssessment(orgId, campaignId, assessmentId, invitationCode, currentTestlet, sessionId, score, duration)
          .pipe(
            map(({ assessmentConfiguration, nextTestlet, sessionId: updatedSessionId, assessmentId: updatedAssessmentId }) =>
              updateAssessmentSuccess({
                testletConfig: {
                  config: assessmentConfiguration,
                  nextTestlet,
                  sessionId: updatedSessionId,
                  assessmentId: updatedAssessmentId,
                },
              }),
            ),
            catchError((error) => of(updateAssessmentFailure({ error }))),
          ),
      ),
    ),
  );
}
